import { Appointment } from 'EntityTypes';
import {
  PracticeInfo,
  PatientInfo,
  HydratedPatientInfo,
  ClaimPatientInvite,
  PatientChartInfo,
  HydratedPracticeInfo,
} from './common';

export enum ResponseStatus {
  success = 'success',
  error = 'error',
}

export type SuccessResponse<T> = {
  data: T;
  status: ResponseStatus.success;
};

export type FailureResponse = {
  status: ResponseStatus.error;
  message: string;
};

export type Response<T> = SuccessResponse<T> | FailureResponse;

export type RQResponse<T> = {
  body: T;
  status: number;
};

export type RQGenericResponse = RQResponse<Response<{}>>;

type ConfirmAppointmentResponseData = {
  appointment: Appointment;
  patient: PatientInfo;
};
export type ConfirmAppointmentSuccessResponse = SuccessResponse<ConfirmAppointmentResponseData>;
export type ConfirmAppointmentResponse = Response<ConfirmAppointmentResponseData>;
export type RQConfirmAppointmentResponse = RQResponse<ConfirmAppointmentResponse>;

export type PracticeSuccessResponse = SuccessResponse<PracticeInfo>;
export type PracticeResponse = Response<HydratedPracticeInfo>;
export type RQPracticeResponse = RQResponse<PracticeResponse>;

export type LoginSuccessResponse = SuccessResponse<HydratedPatientInfo>;
export type LoginResponse = Response<HydratedPatientInfo>;
export type RQLoginResponse = RQResponse<LoginResponse>;

export type ClaimPatientInviteSuccessResponse = SuccessResponse<ClaimPatientInvite>;
export type ClaimPatientInviteResponse = Response<ClaimPatientInvite>;
export type RQClaimPatientInviteResponse = RQResponse<ClaimPatientInviteResponse>;

export type ClaimPatientConfirmSuccessResponse = SuccessResponse<PatientChartInfo>;
export type ClaimPatientConfirmResponse = Response<PatientChartInfo>;
export type RQClaimPatientConfirmResponse = RQResponse<ClaimPatientConfirmResponse>;

export type AvailabilitiesResponseData = {
  [key: string]: {
    [key: string]: number[];
  };
};
export type SuccessAvailabilitiesResponse = SuccessResponse<AvailabilitiesResponseData>;
